/**
 * @name object-fit
 */

export const fit = ({ size, hozitonal, vertical } = {}) => `
        object-fit: ${size || 'cover'};
        object-position: ${hozitonal || 'center'} ${vertical || 'center'};
    `;
